module.exports = __webpack_public_path__ + "public/images/prizes/prize-turkey.3cc72c392da96617d640df21717e4d04.jpg";